<!--
 * @description: 人员名单组选取
 * @fileName: index.vue
 * @author: panlua
 * @date: 2019-07-12 14:32:22
 * @version: V1.0.0
!-->
<template>
  <el-dialog
    :title="$t('personCm.title.groupList')"
    :visible.sync="dialogVisible"
    width="700px">
    <div class="person-group-list">
      <!-- tab切换栏 -->
      <div class="tab-content">
        <ul>
          <li class="tab-item" v-for="(item, index) in tabData" :key="index" :class="item.value === tabIndex && 'active'" @click="tabChangeClick(item)">{{item.label}}</li>
        </ul>
      </div>
      <!-- 搜索区域 -->
      <div class="serarch-content">
        <el-input v-model="name">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
        </el-input>
        <span class="iconfont icon-refresh" @click="refreshClick"></span>
      </div>

      <!-- 表格 -->
      <el-table
        stripe
        v-loading="loading"
        :data="groupList"
        style="width: 100%;"
        height="500">
        <el-table-column
          width="180">
          <template slot-scope="scope">
            <el-radio fill="#0567D5" v-model="tableIndex" :label="scope.$index">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('personCm.label.No')">
          <template slot-scope="scope">
            {{scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('personCm.label.groupName')">
        </el-table-column>
        <template slot="empty">
          <dataEmpty />
        </template>
      </el-table>

      <!-- 按钮区域 -->
      <div class="btn-content">
        <el-button type="primary" @click="sureClick">
          {{$t('personCm.button.confirm')}}
        </el-button>
        <el-button type="info" @click="dialogVisible = false">
          {{$t('personCm.button.cancel')}}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {api} from './api'
import dataEmpty from '@src/components/common/ioc-component/app-data-empty.vue'

export default {
  components: {
    dataEmpty
  },
  data () {
    return {
      dialogVisible: false,
      tabData: [],
      tabIndex: 0,
      name: '',
      tableIndex: null,
      groupList: [],
      loading: false,
      type: null // 类型 1：人员 2：车辆
    }
  },
  methods: {
    /*
     *@name: 打开名单组选取
     *@param:{type} type：类型  tabData：传入tabData，默认选中tab下标 code：选中名单组回填
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 14:47:39
    */
    open (type, tabData, tabIndex, code) {
      this.type = type
      this.tabData = tabData
      this.tabIndex = tabIndex
      this.dialogVisible = true
      this.getGroupList(code)
    },
    /*
     *@name: tab切换
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 15:24:01
    */
    tabChangeClick (item) {
      if (this.tabIndex === item.value) {
        return
      }
      this.tabIndex = item.value
      this.getGroupList()
    },
    /*
     *@name: 重置名单组
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 15:38:24
    */
    refreshClick () {
      this.name = ''
      this.getGroupList()
    },
    /*
     *@name: 搜索名单组
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 15:41:07
    */
    searchClick () {
      this.getGroupList()
    },
    /*
     *@name: 确定回填名单组数据
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 16:10:10
    */
    sureClick () {
      if (this.tableIndex === null) {
        this.$message.warning(this.$t('personCm.title.groupList'))
        return
      }
      let label = ''
      this.tabData.forEach(item => {
        if (item.value === this.tabIndex) {
          label = item.label
        }
      })
      this.$emit('group', {
        group: {
          code: this.groupList[this.tableIndex].code,
          name: this.groupList[this.tableIndex].name
        },
        type: {
          value: this.tabIndex,
          label: label
        }
      })
      this.dialogVisible = false
      // console.log(this.tableIndex)
    },
    /*
     *@name: 获取名单组数据
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 15:41:47
    */
    getGroupList (code) {
      this.tableIndex = null
      this.loading = true
      let url, param
      if (this.type === 1) {
        url = api.queryPersonnelGroupListByType
        param = {
          name: this.name,
          type: this.tabIndex
        }
      } else {
        url = api.queryVehicleGroupList
        param = {
          name: this.name
        }
      }
      this.$fetch(url, param).then(res => {
        if (res.success) {
          this.groupList = res.returnObj
          if (code) {
            this.groupList.forEach((item, index) => {
              if (item.code === code) {
                this.tableIndex = index
              }
            })
          }
        } else {
          this.$message.error(res.msgContent)
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
.person-group-list {
  .tab-content {
    ul {
      display: flex;
      flex-direction: row;
      .tab-item {
        flex: 1;
        text-align: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 14px;
        border-top: 1px solid #405374;
        border-left: 1px solid #405374;
        border-bottom: 1px solid #405374;
        padding: 10px 0;
        &:last-child {
          border-right: 1px solid #405374;
        }
        &.active {
          background-color: #0079FE;
        }
      }
    }
  }
  .serarch-content {
    margin: 10px 0;
    .el-input {
      width: 250px;
    }
    span {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .btn-content {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
